import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const AccountContainer = styled(Box)({
  backgroundColor: '#2E2E2E',
  padding: '20px',
  borderRadius: '12px',
  width: '300px',
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  zIndex: 2,
});
